import { ENDPOINTS } from '../_config';

export const getResourceTypes = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_RESOURCE_TYPE);
    const response = await request.json();

    return response;
  } catch (e) {
    return null;
  }
};
